export const soilmapUrl = {
    de: 'https://gese.wsl.ch/arcgis/rest/services/soilmaps/SoilMaps_DE/MapServer',
    en: 'https://gese.wsl.ch/arcgis/rest/services/soilmaps/SoilMaps_EN/MapServer',
    fr: 'https://gese.wsl.ch/arcgis/rest/services/soilmaps/SoilMaps_FR/MapServer'
}
export const uncertaintymapUrl = {
    de: 'https://gese.wsl.ch/arcgis/rest/services/soilmaps/UncertaintySoilMaps/MapServer',
    en: 'https://gese.wsl.ch/arcgis/rest/services/soilmaps/UncertaintySoilMaps/MapServer',
    fr: 'https://gese.wsl.ch/arcgis/rest/services/soilmaps/UncertaintySoilMaps/MapServer',
}

/*export const token = 'sVnj1Z_rcQCtjjooHvoHCQCWqHLPRZLkkm3o1JbEXoyyWloi-su7gFsFJu4TGA38'*/
